<template>
    <div id="goods-select">
        <div class="content_middle">
            <!-- 查询条件 -->
            <div class="searchBar" style="display: flex;justify-content: space-between;">
                <div style="display: flex">
                    <el-select class="brandSearch" :placeholder="$STR('ORDER.goodsSelect.brand', '请选择品牌')" v-model="selectForm.brandId" filterable
                               clearable>
                        <el-option
                                v-for="item in brandList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                    <el-input
                            class='keywordSearch'
                            v-model="selectForm.keyword"
                            :placeholder="$STR('ORDER.goodsSelect.goodsName', '输入商品名称/SKU')"
                            @keyup.enter.native="getCodeApplyList"></el-input>
                    <el-button class="searchButton" type="primary" plain @click="selectGoods(selectForm.current = 1)">{{$STR('COMMON.common.search', '查询')}}</el-button>
                    <el-button class="searchButton" type="" @click="resetSearch">{{$STR('ORDER.goodsSelect.reset', '重置')}}</el-button>
                </div>
            </div>
            <div style="flex: 1;overflow-y: auto">
                <el-table class="goods-list" ref='multipleTable'
                          @selection-change="handleSelectionChange" :row-key="getRowKey"
                          :data="goodsList.list" style="width: 100%" highlight-current-row>
                    <el-table-column
                            type="selection"
                            :reserve-selection="true"
                            width="55">
                    </el-table-column>
                    <el-table-column :label="$STR('ORDER.goodsSelect.list.no', '编号')" :show-overflow-tooltip="true" prop="goodsCode">
                    </el-table-column>
                    <el-table-column
                            :label="$STR('ORDER.orderList.info', '商品信息')" :show-overflow-tooltip="true" prop="goodsName">
                        <!--<template slot-scope="scope">
                            <div style="display: flex;">
                                <div class="el-text-overflow goods-info">
                                    <p>
                                        <span style="font-size: 16px;font-weight: 600;color: #333333">{{scope.row.name}}</span>
                                    </p>
                                    <p v-if="scope.row.remarks"><span>{{$STR('ORDER.goodsSelect.list.remark', '备注:')}}</span><span>{{scope.row.remarks}}</span></p>
                                </div>
                            </div>
                        </template>-->
                    </el-table-column>
                    <el-table-column
                            :label="this.$STR('goods.goodsManager.table.brand', '所属品牌')" :show-overflow-tooltip="true" prop="brandName">
                    </el-table-column>
                </el-table>
            </div>
            <div>
                <el-pagination
                        class="goods-page"
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="selectForm.current"
                        :page-sizes="[10, 20, 30, 40]"
                        :page-size="selectForm.rows"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="goodsList.count">
                </el-pagination>
            </div>
        </div>
        <div style="text-align: center;background: white; padding: 10px 0">
            <el-button @click="cancelAction">{{$STR('ORDER.goodsSelect.cancel', '取消操作')}}</el-button>
            <el-button :disabled="goodsSelection.length == 0" v-duplication @click="nextStep" type="primary" plain>{{$STR('ORDER.goodsSelect.confirm', '确定选择')}}</el-button>
        </div>
    </div>
</template>
<script>
import {mapState, mapGetters, mapActions} from 'vuex';
export default {
    props: ['chosenGoodList'],
    computed: {
        currentTab: {
            ...mapState({
                get: state => state.tabInfo.activeIndex
            }),
            ...mapActions({
                set: 'setActiveIndex'
            })
        }
    },
    watch: {
        chosenGoodList (val) {
            this.goodsSelection = JSON.parse(JSON.stringify(val));
            let selectedIds = [];
            this.goodsSelection.forEach(item => selectedIds.push(item.id));
            this.goodsList.list.forEach(i => {
                this.$refs['multipleTable'].toggleRowSelection(i, selectedIds.includes(i.id));
            });
        }
    },
    data () {
        return {
            brandList: [],
            selectForm: {
                brandId: '',
                keyword: '',
                current: 1,
                order: 'createDate',
                rows: 20,
                asc: false,
                goodsType: 1
            },
            goodsList: {
                list: [],
                count: 0
            },
            goodsSelection: []
        };
    },
    components: {
    },
    created() {
        this.getBrandList();
        this.getGoodsList();
    },
    methods: {
        getBrandList() {
            this.$http.get(WebApi.goods.brand).then(response => {
                this.brandList = response.data.data.rows;
            });
        },
        selectGoods() {
            this.getGoodsList();
        },
        resetSearch() {
            this.selectForm.brandId = '';
            this.selectForm.keyword = '';
        },
        getGoodsList() {
            this.$http.get(WebApi.goods.skuPublish, {
                params: this.selectForm
            }).then(response => {
                this.goodsList.list = response.data.rows;
                this.goodsList.count = response.data.total;
            });
        },
        handleSizeChange(val) {
            this.selectForm.rows = val;
            this.getGoodsList();
        },
        handleCurrentChange(val) {
            this.selectForm.current = val;
            this.getGoodsList();
        },
        handleSelectionChange(val) {
            this.goodsSelection = val;
        },
        cancelAction() {
            this.clearSelection();
            this.selectForm = {
                brandId: '',
                keyword: '',
                current: 1,
                order: 'createDate',
                rows: 20,
                asc: false,
                goodsType: 1
            };
            // this.$store.dispatch('delectCurentTabs', this.currentTab).then(() => {});
            this.$emit('cancelSubmitGoods', false);
        },
        nextStep() {
            this.$emit('submitGoods', this.goodsSelection);
        },
        getRowKey(row) {
            return row.id;
        },
        clearSelection() {
            this.$refs.multipleTable.clearSelection();
        },
        goodsSelectionList(data) {
            this.$refs.multipleTable.clearSelection();
            data.forEach((item) => {
                //设置该表格选框选中
                this.$refs.multipleTable.toggleRowSelection(item);
            });
            this.goodsSelection = data;
        }
    }
};
</script>

<style scoped>
    #goods-select{
        display: flex;
        flex-direction: column;
        height: 100%;
    }
    #goods-select .searchBar {
        padding: 10px 0;
    }

    #goods-select .brandSearch {
        width: 200px;
    }
    #goods-select .keywordSearch {
        margin: 0 10px;
    }

    #goods-select .content_middle {
        background-color: white;
        flex: 1;
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        /*height: 500px;*/
        /*overflow-y: scroll;*/
    }

    #goods-select .goods-list {
    }
    #goods-select .goods-page {
        background-color: white;
    }
</style>



// WEBPACK FOOTER //
// src/views/cloud/order/stockIn/components/goodsSelect.vue